import { bindActionCreators } from 'redux'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import React from 'react'
import PropTypes from 'prop-types'

import * as surveyActions from '../survey.actions'
import * as selectors from '../survey.selectors'

/**
 *  Survey viewer
 */
class SurveyViewer extends React.Component {
  /**
   *  Render each user data
   */
  constructor(props) {
    super(props)
    this.state = {
      applicable: '',
      opinion: '',
      comments: '',
      suggestions: '',
    }
  }

  /**
   *  Send survey
   */
  submitSurvey(event) {
    const { sendSurvey } = this.props

    sendSurvey(this.state)
    event.preventDefault()
  }

  /**
   * render checkbox opinion
   */
  renderBoxOpinion(value) {
    const { clearResponse } = this.props

    return (
      <div key={value}>
        <label htmlFor={'opinion'}>{value}</label>
        <input
          type="radio"
          className={'radio'}
          required
          name="opinion"
          value={value}
          onChange={(event) => {
            clearResponse()
            this.setState({ opinion: event.target.value })
          }}
        />
      </div>
    )
  }

  /**
   * render checkbox applicable
   */
  renderBoxApplicable() {
    const { clearResponse } = this.props
    const question1 = <b>1.</b>

    return (
      <div className="survey-body-block z-index6">
        <div className="survey-body-question">
          <FormattedMessage id={'survey.question1'} values={{ ordinal: question1 }} />
        </div>
        <div className={'survey-body-form'}>
          <input
            type="radio"
            className={'radio'}
            required
            value="yes"
            name="applicable"
            onChange={(event) => {
              clearResponse()
              this.setState({ applicable: event.target.value })
            }}
          />
          <label htmlFor="applicable">
            <FormattedMessage id="survey.yes" />
          </label>
        </div>
        <div className={'survey-body-form'}>
          <input
            type="radio"
            className={'radio'}
            required
            value="no"
            name="applicable"
            onChange={(event) => {
              this.setState({ applicable: event.target.value })
              clearResponse()
            }}
          />
          <label htmlFor="applicable">
            <FormattedMessage id="survey.no" />
          </label>
        </div>
      </div>
    )
  }

  /**
   *  Render error message
   */
  renderError() {
    // const { applicable, opinion, comments, suggestions } = this.state

    // if (!applicable || !opinion || !comments || !suggestions) {
    //   return (
    //     <FormattedMessage id='survey.uncomplete' />
    //   )
    // }
    return <FormattedMessage id="survey.error" />
  }

  /**
   *  Render success message
   */
  renderSuccess() {
    return <FormattedMessage id="survey.successed" />
  }

  /**
   *  Render recommendation box.
   */
  renderBoxRecommendation() {
    const question2 = <b>2.</b>
    const opinionOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    return (
      <div className="survey-body-block">
        <div className="survey-body-question">
          <FormattedMessage id={'survey.question2'} values={{ ordinal: question2 }} />
        </div>
        <div className="survey-body-form">
          {opinionOptions.map((value) => this.renderBoxOpinion(value))}
        </div>
      </div>
    )
  }

  /**
   *  Render comments box.
   */
  renderBoxComments() {
    const { comments } = this.state
    const { clearResponse } = this.props
    const question3 = <b>3.</b>

    return (
      <div className={'survey-body-block'}>
        <div className={'survey-body-question'}>
          <FormattedMessage id={'survey.question3'} values={{ ordinal: question3 }} />
        </div>
        <div className={'survey-body-form'}>
          <textarea
            name={'comments'}
            required
            cols={'30'}
            rows={'10'}
            value={comments}
            onChange={(event) => {
              clearResponse()
              this.setState({ comments: event.target.value })
            }}
          />
        </div>
      </div>
    )
  }

  /**
   *  Render suggestions box.
   */
  renderBoxSuggestions() {
    const { suggestions } = this.state
    const { clearResponse } = this.props
    const question4 = <b>4.</b>

    return (
      <div className={'survey-body-block'}>
        <div className={'survey-body-question'}>
          <FormattedMessage id={'survey.question4'} values={{ ordinal: question4 }} />
        </div>
        <div className={'survey-body-form'}>
          <textarea
            name={'suggestions'}
            required
            cols={'30'}
            rows={'10'}
            value={suggestions}
            onChange={(event) => {
              clearResponse()
              this.setState({ suggestions: event.target.value })
            }}
          />
        </div>
      </div>
    )
  }

  /**
   *  Render component
   */
  render() {
    const { intl, isResponseOK, isResponseError, clearResponse } = this.props

    return (
      <div className="survey-container background--mars">
        <form
          className={'survey'}
          onSubmit={(event) => {
            clearResponse()
            this.submitSurvey(event)
          }}
        >
          <div className={'survey-header'}>
            <div className={'survey-header-item'}>
              <img src="https://api.gamelearn.io/pacificmicroservices/survey_assets/imgs/game_learn_logo.gif" />
            </div>

            <div className={'survey-header-item'}>
              <h1 className={'h1'}>
                <FormattedMessage id={'survey.title'} />
              </h1>
              <p>
                <FormattedMessage id={'survey.subtitle'} />
              </p>
            </div>

            <div className={'survey-header-item'}>
              <img src={null} />
            </div>
          </div>

          <div className={'survey-body'}>
            <div className={'survey-body-title'}>
              <FormattedMessage id={'survey.bodyTitle'} />
            </div>

            {this.renderBoxApplicable()}
            {this.renderBoxRecommendation()}
            {this.renderBoxComments()}
            {this.renderBoxSuggestions()}

            <div className={'survey-body-title'}>
              <FormattedMessage id={'survey.notice'} />
            </div>
            <br></br>
            <input
              className="survey-send-button"
              type="submit"
              value={intl.formatMessage({ id: 'survey.submit' })}
            />
            {isResponseError ? this.renderError() : null}
            {isResponseOK ? this.renderSuccess() : null}
          </div>
        </form>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    isResponseOK: selectors.isResponseOK(state),
    isResponseError: selectors.isResponseError(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendSurvey: bindActionCreators(surveyActions.sendSurvey, dispatch),
    clearResponse: bindActionCreators(surveyActions.clearResponse, dispatch),
  }
}
SurveyViewer.propTypes = {
  sendSurvey: PropTypes.func,
  clearResponse: PropTypes.func,
  isResponseOK: PropTypes.bool,
  isResponseError: PropTypes.bool,
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SurveyViewer))
